module.exports = __webpack_public_path__ + "static/media/ic-notification-error.654cd9aa.svg";